<template>
  <div>
    <div>
      <a
        @click="startVetting()"
        v-if="!isVetted"
        class="button is-danger mb-3"
        >Start Vetting</a
      >
      <p v-else>{{ payload.applicant_status }}</p>
    </div>
    <div>
      <a
        @click="startVettingAdvanced()"
        v-if="!isVetted"
        class="button is-danger"
        >Start Vetting Advanced</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  props: ['payload'],
  name: 'is-vetted',
  computed: {
    isVetted () {
      return this.payload.applicant_status && ['vetted', 'completed', 'irrelevant'].includes(this.payload.applicant_status)
    }
  },
  methods: {
    startVetting () {
      let modal_title = this.payload.first_name + ' ' + this.payload.last_name + ' Vetting'
      this.create({ designator: 'vetting-modal', component_name: 'VettingForm', applicant_id: this.payload.resource_id, modal_title: modal_title, ignore_escape_button: true, modal_width: 1500, is_center_modal: true })
    },
    startVettingAdvanced () {
      let modal_title = this.payload.first_name + ' ' + this.payload.last_name + ' Vetting'
      this.create({ designator: 'vetting-modal', component_name: 'ModalVettingForm', applicant_id: this.payload.resource_id, modal_title: modal_title, ignore_escape_button: true, modal_width: 2400, is_center_modal: true })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
